<ng-container *ngIf="node">
  <mat-form-field *ngIf="hasEvidenceFilter && !hideEvidenceFilter" appearance="outline" class="full-width" subscriptSizing="dynamic">
    <mat-label>{{ 'ppwr.evidenceFilterLabel' | transloco }}</mat-label>
    <mat-select multiple [value]="excludedEvidenceTypeIds" (selectionChange)="onEvidenceTypesChange($event.value)">
      <mat-option *ngFor="let evidenceType of evidenceTypes" [value]="evidenceType.id">{{ evidenceType.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-expansion-panel *ngIf="hasCustomFields">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'fieldNamesForExport.customFields' | transloco }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="custom-field-list">
      <mat-checkbox *ngFor="let field of customFieldOptions" [checked]="isCustomFieldSelected(field.id)" (change)="toggleCustomField(field.id)">
        {{ field.name }}
      </mat-checkbox>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="booleanKeys.length" [expanded]="depth < 1">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'dataManagement.organizationSettings.sections.generalData' | transloco }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="custom-field-list">
      <mat-checkbox *ngFor="let key of booleanKeys" class="field-checkbox" [checked]="isChecked(key)" (change)="toggle(key)">
        {{ fieldLabel(key) }}
        <span *ngIf="isMinimumRequirement(key)" class="minimum-requirement-dot"></span>
      </mat-checkbox>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel *ngFor="let key of groupKeys" [expanded]="depth < 1">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ fieldLabel(key) }}</mat-panel-title>
    </mat-expansion-panel-header>
    <app-profile-field-tree [node]="groupNode(key)" [depth]="depth + 1" [customFieldOptions]="[]" [minimumRequirementKeys]="minimumRequirementKeys"> </app-profile-field-tree>
  </mat-expansion-panel>
</ng-container>
